/* global $:true module:true Foundation:true */
/**
 * Foundation Configuration
 */

// Utilities
import debug from "debug";

const MODULE_NAME = 'core/vendor/foundation';
const log = debug(MODULE_NAME);


// Foundation
import '@vendor/foundation/js/foundation.core';
import '@vendor/foundation/js/foundation.util.mediaQuery';
import '@vendor/foundation/js/foundation.util.keyboard';
import '@vendor/foundation/js/foundation.util.box';
import '@vendor/foundation/js/foundation.util.triggers';
import '@vendor/foundation/js/foundation.util.motion';
import '@vendor/foundation/js/foundation.accordion';
import '@vendor/foundation/js/foundation.abide';
import '@vendor/foundation/js/foundation.dropdown';
import '@vendor/foundation/js/foundation.toggler';
import '@vendor/foundation/js/foundation.tabs';
import '@vendor/foundation/js/foundation.reveal';
import '@vendor/foundation/js/foundation.tooltip';

// Imports
import validatorExtensions from './extensions/abide-validators';
import responsiveTabs from './extensions/responsive-tabs';


// Constants
const ABIDE_SELECTOR = 'form[data-abide]';

// Export
export function exec () {
	log('Running...');
	log(`Available foundation modules: ${Object.keys(Foundation)}`);

	// Check Foundation has loaded correctly
	if (!Foundation) {
		log('Foundation not found.');

		return;
	}

	if (Foundation.Abide) {
		// Add `novalidate` attribute if Abide is available
		$(ABIDE_SELECTOR).attr('novalidate', '');

		// Load extra validators
		validatorExtensions();
	} else {
		log('Foundation Abide module not loaded.');
	}

	if (Foundation.Tabs && Foundation.Accordion) {
		responsiveTabs();
	} else {
		log('Foundation tab and accordion modules not loaded');
	}

	// Configure and Run
	$(document).foundation();
	log('Foundation initialised.');

	if (Foundation.Reveal) {
		$('.reveal').each(function InitialiseRevealModals () {

			if ($(this).hasClass('is--open')) {
				$(this).foundation('open');
			}
		});
	} else {
		log('Foundation reveal module not loaded');
	}

}



